import { getTotalOrderPrice } from '../../../../_common/reducers/orders';
import { ProductForSale } from '../../../../types/Product';
import { getCustomOfferForConsumer } from '../../../../utils/pricing';
import { ProductWithUnit } from '../../add-orderline/ProductList';
import {
  track,
  CREATE_ORDER_FLOW_CLICK_PLACE_ORDER
} from '../../../../utils/mixpanel';
import Logger from '../../../../services/Logger';
import { OrderLine } from '../../../../types/Order';

export const trackOrderFlowPlaceOrder = (
  orderLines: OrderLine[],
  selectedProducts: ProductWithUnit[],
  consumerId: string | undefined,
  consumerName: string | undefined,
  products: ProductForSale[]
) => {
  try {
    const orderTotal = getTotalOrderPrice(orderLines);
    const containsCustomOffer = selectedProducts.some(selectedProduct => {
      const product = products.find(p => {
        return p._id === selectedProduct.productId;
      });
      return getCustomOfferForConsumer(product?.prices, consumerId);
    });
    track(CREATE_ORDER_FLOW_CLICK_PLACE_ORDER, {
      numProducts: orderLines.length,
      containsCustomOffer,
      orderTotal,
      consumerName
    });
  } catch (error) {
    Logger.error(error as Error);
  }
};
